export class AnonymousSet { 
    isAnonymity = false;
    anonymous = '审批人';
}
